<template>
    <div class="container">
        <div class="container-content">
            <!-- 标题 -->
            <div class="container-content-title">数据管理</div>
            <!-- 内容 -->
            <div class="content">
                <!-- 左侧的统计图 -->
                <div class="left-statistics">
                    <DataStatistics :unitList="unitList"></DataStatistics>
                </div>
                <!-- 右侧列表 -->
                <div class="right-data">
                    <DataList :unitList="unitList"></DataList>
                </div>
            </div>
        </div>
        <!-- 底部 -->
        <ViewBottom></ViewBottom>
    </div>
</template>
<script>
import ViewBottom from '../../components/ViewBottom.vue';
import DataList from './Components/DataList.vue';
import DataStatistics from './Components/DataStatistics.vue';
import { GetUnitList } from '@/http/api/api-hb'
export default {
    components: { ViewBottom, DataList, DataStatistics },
    data() {
        return {
            unitList: []
        }
    },
    mounted() {
        this.requestUnitList()
    },
    methods: {
        // 获取施工单位列表
        requestUnitList() {
            GetUnitList({ pid: 0 }).then(res => {
                if (res.code == 200) {
                    this.unitList = res.data
                    // this.unitArray.unshift({ id: 0, deptName: '全部施工单位'})
                }
            })
        },
    },
}
</script>
<style scoped>
    .container-content .content {
        width: 100%;
        height: calc(100% - 48px);
        display: flex;
    }
    .content .left-statistics {
        width: 460px;
        height: 100%;
        /* background-color: silver; */
        margin-right: 12px;
    }
    .content .right-data {
        width: calc(100% - 472px);
        height: 100%;
        background-color: seashell;
    }
</style>